export default "__VITE_ASSET__CBSiAPU3__"